import { render } from "./Roles.vue?vue&type=template&id=6e374fad&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"

import "./Roles.vue?vue&type=style&index=0&id=6e374fad&scoped=true&lang=css"
import "./Roles.vue?vue&type=style&index=1&id=6e374fad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e374fad"]])

export default __exports__